import { render } from "./PartialDesignDynamicPlaceholder.vue?vue&type=template&id=8a4bb3d0"
import script from "./PartialDesignDynamicPlaceholder.vue?vue&type=script&lang=js"
export * from "./PartialDesignDynamicPlaceholder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__